import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { queryClient } from './queryClient';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';
import 'react-image-crop/dist/ReactCrop.css';
export * from './components/organisms/AuthContext';

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
  document.getElementById('root')
);